import { RELEASE_ID } from './release';

export function parseVersion(text: string): string | undefined {
    const m = text.match(/PCS_VERSION\s*=\s*'([^']+)';/);
    if (m !== null) {
        return m[1];
    }
}
// interval to check for updates in s
const updateCheckInterval = 300 * 1000;

// stores unix ts of last update check
let lastUpdateCheck: number;

export function reloadPage(): void {
    window.location.reload();
}

export function fireUpdateRequest(onUpdate: () => void): void {
    const releaseId = RELEASE_ID;
    fetch(`/?date=${Date.now()}`)
        .then(result => {
            if (!result.ok) return;
            return result.text();
        })
        .then(text => {
            if (!text) return;
            const serverVersion = parseVersion(text);
            if (!releaseId || !serverVersion) {
                return;
            }

            if (document && document.location && serverVersion !== releaseId) {
                onUpdate();
            }
        })
        .catch(() => {});
}

export function initUpdater(onUpdate: () => void = reloadPage): void {
    lastUpdateCheck = Date.now();

    fireUpdateRequest(onUpdate);

    (function updateCheck(): void {
        if (!requestAnimationFrame) return;
        requestAnimationFrame(updateCheck);
        if (Date.now() > lastUpdateCheck + updateCheckInterval) {
            lastUpdateCheck = Date.now();

            fireUpdateRequest(onUpdate);
        }
    })();
}
